import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { createErrorFunction } from '../utils/TypescriptHelpers';

export function createDefaultSiteUrls(): SiteUrls {
  const siteUrls: { [key: string]: unknown } = new SiteUrls({ siteUrlName: '' }) as unknown as { [key: string]: unknown };
  for (const key in siteUrls) {
    if (typeof siteUrls[key] === 'function') {
      siteUrls[key] = createErrorFunction(`Function of default SiteUrls context called: ${key}`);
    }
  }
  return siteUrls as unknown as SiteUrls;
}

export const noopSiteUrls = createDefaultSiteUrls();

export const SiteUrlsContext = React.createContext<SiteUrls>(noopSiteUrls);
